import * as moment from 'moment'

const identityModule = {
    namespaced: true,
    persistent: true,
    state: {
        userId: null,
        username: null,
        email: null,
        firstName: null,
        lastName: null,
        roles: [],
        apiToken: null,
        apiTokenExpiresAt: null,
        locale: null
    },
    mutations: {
        setAuthInfo (state, payload) {
            state.userId = payload.id;
            state.username = payload.username;
            state.email = payload.email;
            state.firstName = payload.first_name;
            state.lastName = payload.last_name;
            state.roles = payload.roles;
            state.apiToken = payload.api_token;
            state.apiTokenExpiresAt = payload.api_token_expires_at;
            state.locale = payload.locale;
        },
        removeAuthInfo (state) {
            state.userId = null;
            state.username = null;
            state.email = null;
            state.firstName = null;
            state.lastName = null;
            state.roles = [];
            state.apiToken = null;
            state.apiTokenExpiresAt = null;
            state.locale = null;
        },
        setApiTokenExpiresAt (state, apiTokenExpiresAt) {
            state.apiTokenExpiresAt = apiTokenExpiresAt;
        },
        setLocale (state, locale) {
            state.locale = locale;
        }
    },
    getters: {
        getUserId: state => {
            return state.userId;
        },
        getUsername: state => {
            return state.username;
        },
        getEmail: state => {
            return state.email;
        },
        getFirstName: state => {
            return state.firstName;
        },
        getLastName: state => {
            return state.lastName;
        },
        getRoles: state => {
            return state.roles;
        },
        getApiToken: state => {
            return state.apiToken;
        },
        getApiTokenExpiresAt: state => {
            return state.apiTokenExpiresAt;
        },
        getLocale: state => {
            return state.locale ? state.locale : process.env.VUE_APP_I18N_FALLBACK_LOCALE;
        },
        isAuthenticated: state => {
            return state.apiToken !== null &&
                state.apiTokenExpiresAt !== null &&
                moment(state.apiTokenExpiresAt).isAfter(moment())
        }
    }
};

export default identityModule;
